var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomLegacy = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.806 11.477c.248.098.491-.14.409-.394-.564-1.738-2.607-2.386-4.505-.844-.999.811-1.374.983-1.384.988.659.658 1.41 2.867 3.052 3.111 1.809.328 3.41-1.45 2.1-2.265a5.59 5.59 0 0 0-2.962-.846 5.607 5.607 0 0 1 3.29.25zM22.994 10.239c-3.277-2.663-5.367 1.536-4.068 1.12a5.587 5.587 0 0 1 2.943-.132 5.638 5.638 0 0 0-4.348 2.064c.086-2.01.217-3.267.369-4.203.876-.03 2.043-.738 2.684-1.975 1.105-1.978.593-4.006.428-5.285-.864.84-4.636-.145-6.131 2.418-.66 1.132-.469 2.51.226 3.517.22.32.746.166.761-.221.065-1.685.904-2.957 2.467-3.662a7.603 7.603 0 0 0-1.4 2.977c-.37 1.638-.756 2.713-.898 7.934a.935.935 0 0 0 .944.96.95.95 0 0 0 .86-.601 4.258 4.258 0 0 1 1.183-1.606 2.508 2.508 0 0 0 2.312.794c1.634-.243 2.397-2.457 3.052-3.111-.01-.005-.385-.177-1.384-.988z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.812 16.744c-1.024-.695-2.14-.2-2.652.096l-6.426 4.704H14.97l-.941-.94h3.456c1.04 0 2.203-.677 2.203-1.882 0-1.28-1.164-1.882-2.203-1.882H16.19c-.962 0-2.087.086-2.88-.339a5.603 5.603 0 0 0-2.546-.601c-1.554 0-2.945.62-3.899 1.597L1.8 22.484l5.645 5.645 1.881-2.822h8.891c.948 0 1.864-.348 2.573-.978l7.087-6.296c.394-.35.371-.993-.065-1.29z",
    fill: "#F2AE18"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomLegacy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-legacy.38cbcf4570e8c4b789be31e8292df4eb.svg";